export default __webpack_public_path__ + "static/media/Icon feather-arrow-right.23482f7d.svg";